import React from "react";
import { Button, Form, Alert, Typography, Icon, Modal, Input } from "antd";
import findInstagramUrl1 from "../assets/findInstagramUrl1.png";
import findInstagramUrl2 from "../assets/findInstagramUrl2.png";

const FormItem = Form.Item;
const { Title } = Typography;

function InstagramError(props) {
  return (
    <div>
      <Alert
        message={props.error}
        description="Please return to the email, review the requirements and click submit again to verify your post. If the problem persists, submit below or reply to our email so we can investigate."
        type="error"
        showIcon
      />
      <Title level={4} style={styles.heading}>
        Confirm your post link manually:
        <FormItem
          extra={
            <a onClick={postUrlHelpModal}>
              How do I find my Instagram post link?
              {"\u00A0"}
              <Icon type="info-circle" theme="outlined" />
            </a>
          }
          validateStatus={props.invalidPostUrl}
          help={
            props.invalidPostUrl == "error"
              ? "Invalid Instagram post link"
              : null
          } //show if invalid
        >
          <Input
            name="postUrl"
            placeholder={"https://instagram.com/p/Bi22vEOHPBR/"}
            onChange={props.handleInputChange}
            value={props.postUrl}
          />
        </FormItem>
        <Button onClick={props.submitPostUrl} size="large" type="primary">
          Submit
        </Button>
      </Title>
    </div>
  );
}

const postUrlHelpModal = () => {
  //renders modal on " How do I find my Instagram Post URL?" click
  Modal.info({
    icon: "no icon",
    title: "How to find an Instagram post URL",
    maskClosable: true,
    content: (
      <div style={{ overflowY: "auto" }}>
        <img
          style={{ width: "100%", marginBottom: "5%" }}
          src={findInstagramUrl1}
        />
        <img style={{ width: "100%" }} src={findInstagramUrl2} />
      </div>
    ),
    onOk() {}
  });
};

const styles = {
  heading: { fontWeight: "300" }
};

export default InstagramError;
